export class OrderSimple {

	constructor() {
		this.btn = $('.btn-more');

		this.actions();
	}

	actions() {

		this.btn.on('click', function(){
			$(this).closest('.row-order').find('.simple-resume').toggleClass('is-simple-visibile');
		});

	}

}


// WEBPACK FOOTER //
// ./src/js/modules/account.js